import type { QuestionDefinition } from "@reno-estimator/core";
import { builtInsQuestion, flooringQuestion, lightingQuestion, paintingQuestion } from "./interior-room-shared.js";

/**
 * Laundry Room (Phase 13A) - see rules/laundry-room.ts for the matching
 * calculator. No trim or windows/doors question; plumbing scope is its
 * own tiered question here (rather than relying on the common
 * plumbing_changes flag alone) since plumbing is central to a laundry
 * room renovation, not an edge case.
 */
export const laundryRoomQuestions: QuestionDefinition[] = [
  flooringQuestion("laundry_room", 200, "laundry room"),
  paintingQuestion("laundry_room", 210),
  lightingQuestion("laundry_room", 230),
  builtInsQuestion("laundry_room", 240, "What about cabinetry or a folding station?", "Custom cabinetry/folding station"),
  {
    id: "laundry_room_plumbing_scope",
    projectTypes: ["laundry_room"],
    inputType: "single_select",
    prompt: "What plumbing work does this involve?",
    required: false,
    options: [
      { id: "none", label: "None" },
      { id: "relocate_hookups", label: "Relocate washer/dryer hookups" },
      { id: "add_utility_sink", label: "Add a utility sink" }
    ],
    order: 260
  }
];
